import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  id?: string;
  compact?: boolean;
  className?: string;
};
export function CtaButton({
  label,
  id,
  compact = false,
  className = ''
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 text-center font-display font-semibold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#0F6E32] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-cta-hover active:translate-y-1 active:shadow-[0_2px_0_0_#0F6E32] focus:outline-none focus-visible:ring-4 focus-visible:ring-radar/50 ${compact ? 'py-3.5 text-lg' : 'py-5 text-[1.35rem] sm:text-2xl'} ${className}`} data-id="element-123" data-mp="ckj5ve0683k4">
      <span data-id="element-124" data-mp="159ga4d7jrztv">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-125" data-mp="15a9dd47as779" />
    </a>;
}